import React from 'react';
import CurrencyInput from 'react-currency-input-field';

const MoneyFormat = ({ value, onChange, placeholder }) => (
    <CurrencyInput
        name="rate"
        prefix="$"
        decimalsLimit={2}
        decimalScale={2}
        value={value ?? ''}
        onValueChange={(val) => onChange(val)}
    />
);

export default MoneyFormat;